<div class="store">
    <nav class="navbar bg-white">
        <div class="container">
          <div class="d-flex align-items-end justify-content-between w-100 flex-nowrap">
                <div class="d-flex flex-nowrap">
                    <a class="btn p-0 me-2 d-md-none">
                        <img src="./assets/shoponlinenew/backArrow.svg" style="margin-top: 8px;" alt="backArrow" class="img-fluid backArrow" />
                    </a>
                    <a class="navbar-brand me-2">
                        <img src="./assets/shoponlinenew/instaCard.svg" style="margin-top: 4px;" alt="instaCard" class="img-fluid instaCard" />
                    </a>
                </div>
                <div>
                    <a class="navbar-brand m-0">
                        <img src="./assets/shoponlinenew/tvsCredit.svg" height="20px" alt="tvsCredit" class="img-fluid tvsCredit" />
                    </a>
                </div>
          </div>
          
        </div>
    </nav>
    <div class="searchbar py-4 bg-white">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-12 col-md-8 col-lg-5">
                    <div class="col-wrap">
                        <form action="#" method="post" class="form">
                            <div class="input-group align-items-center">
                                <span class="searchIcon">
                                    <img src="./assets/shoponlinenew/search.svg" alt="search" class="img-fluid opacity-50" />
                                </span>
                                <input type="text" class="form-control border-0 bg-transparent" name="search-text" id="search-text"  placeholder="Search..." [(ngModel)]="searchText"
                                (keyup)="onSearchKeyUp()">
                                <a href="#" class="audioIcon">
                                    <img src="./assets/shoponlinenew/microphone.svg" alt="microphone" class="img-fluid" />
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- <div  style="text-align: right;" class="col-2 col-md-4 col-lg-7 d-none d-md-block">
                    <div class="col-wrap text-end">
                        <a href="#" class="qustionLink">
                            <img src="./assets/shoponlinenew/ques-mark.svg" alt="support" class="img-fluid" />
                        </a>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    <div class="filterbar pt-3 bg-white">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="col-wrap">
                        <div style="justify-content: space-between !important;
                        display: flex !important;" class="filters d-flex overflow-auto w-100 flex-nowrap pb-3 justify-content-lg-center">
                            <a class="btn active" *ngFor="let data of mainList;">
                                <div (click)="getSelectedCategoryList(data.CATEGORY_NAME)">
                                <img src="{{data.IMG_PATH}}" alt="{{data.CATEGORY_NAME}}"  class="img-fluid"  />
                                <div class="text fw-bold" [ngClass]="{'text-wrap': data.CATEGORY_NAME !='E-commerce'}">
                                    {{data.CATEGORY_NAME.replace("and","&")}}
                                </div>
                                <div class="icon" *ngIf="data.CATEGORY_NAME==selectedCategory">
                                    <img src="./assets/shoponlinenew/check.svg" alt="{{data.CATEGORY_NAME}}" class="img-fluid" />
                                </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="banner pb-5" >
        <div class="container" >
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <div class="carousel-indicators pb-2">
                  <button type="button" data-target="#carouselExampleIndicators" data-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                  <button type="button" data-target="#carouselExampleIndicators" data-slide-to="1" aria-label="Slide 2"></button>
                  <button type="button" data-target="#carouselExampleIndicators" data-slide-to="2" aria-label="Slide 3"></button>
                  <button type="button" data-target="#carouselExampleIndicators" data-slide-to="3" aria-label="Slide 4"></button>
                </div>
                <div class="carousel-inner" >
                  <div *ngFor="let data of bannerList; let i=index" class="carousel-item "  [ngClass]="(i === 0) ? 'active' : ''" >
                    <picture class="d-block w-100 rounded-4">
                        <!-- <source media="(min-width:768px)" /> -->
                        <img src="{{data.IMAGE_PATH}}" class="desktop_img d-block w-100 rounded-5" alt="banner" />
                        <img src="{{data.M_IMAGE_PATH}}" class="mobile_img  d-block w-100 rounded-5" alt="banner" />
                    </picture>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brands pb-5 brands2 ">
        <div class="container">
            <nav class="nav justify-content-between align-items-center pb-3">
                <div>
                    <h5 class="h5 f_thick">Shop by brand</h5>
                </div>
                <div>
                    <a (click)="redirectToNextPage()" class="btn btn-link fw-bold text-black-50 th-black text-decoration-none">
                        <span class="text f_thick"><b>View More </b></span>
                        <span class="icon"><img src="./assets/shoponlinenew/right-arrow.svg" alt="arrow" class="img-fluid" /></span>
                    </a>
                </div>
            </nav>
            <div class="row g-2 g-md-4 align-items-stretch diff">
                <div class="main-card" *ngIf="dataTobeDisplay.length;else elseproperty"></div>
                <div class="desktop_img col-4 col-sm-4 col-lg-3 mb-4" *ngFor="let categoryData of dataTobeDisplay;">
                    <div class="col-wrap h-100" >
                        <a (click)="redirectUrl(categoryData)" class="btn p-0 text-decoration-none h-100" title="{{categoryData.BRAND_NAME}}" target="_blank">
                            <img src="{{categoryData.IMG_PATH}}" alt="brands" class="desktop_img img-fluid rounded-3 h-100" />
                        </a>
                    </div>
                </div>
                <div class="mobile_img col-4 col-sm-4 col-lg-3 mb-2 border_def" *ngFor="let categoryData of dataTobeDisplay;">
                    <div class="col-wrap h-100" >
                        <a (click)="redirectUrl(categoryData)" class="btn p-0 text-decoration-none h-100" title="{{categoryData.BRAND_NAME}}" target="_blank">
                            <img src="{{categoryData.M_IMG_PATH}}" alt="brands" class="mobile_img d-block w-100 rounded-4" />
                        </a>
                    </div>
                </div>
                <ng-template #elseproperty>
                    <div class="col mb-12">
                        <div class="h-100" >
                           
                            <div>
                                Sorry no data found...
                            </div>
                            
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    
</div>
<loader *ngIf="loader"></loader>
